import { render } from "./RemoteContent.vue?vue&type=template&id=b4139f2a&ts=true"
import script from "./RemoteContent.vue?vue&type=script&lang=ts"
export * from "./RemoteContent.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__